<template>
  <div class="page page--privacy contact">
    <div class="cta">
      <div class="cta__content">
      </div>
    </div>
    <div class="page__content">
      <div class="page__content__block">
        <div>
          <h1>{{ $t('privacy.title') }}</h1>
        </div>
        <div v-html="$t('privacy.text')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy.vue"
}
</script>